import { getSameAttribute, removeNull, sortArray } from '@/utils/handleData'
import { buildShipmentSignQcodeInfo } from '@/utils/scanQrcode'

function resolvePendingAuditStatus(appliedList) {
  const list = Array.isArray(appliedList) ? appliedList : []
  const pending = list.find((item) => item && item.auditStatus === '2')
  if (!pending) return ''
  return pending.appliedType === '补方' ? '待补方审核' : '待审核'
}

function resolveDisplayExecuteStatus(item) {
  const pendingStatus = resolvePendingAuditStatus(item.appliedList)
  if (pendingStatus) return pendingStatus
  return item.executeStatus ? item.executeStatus : '待生产'
}

export function supplyApplicationBlockReason(order) {
  if (!order) return '未查询到浇筑令信息，不可提交补方申请。'
  const status = order.executeStatus || ''
  const completed =
    order.isCompleted === '是' ||
    order.isCompleted === '1' ||
    status === '已完成'
  if (completed) return '当前浇筑令已完成，不可提交补方申请。'
  if (status === '已中止') return '当前浇筑令已中止，不可提交补方申请。'
  if (order.auditQuantity) {
    return '当前浇筑令有待审核申请信息，不可提交补方申请。'
  }
  const shipments = order.shipmentList || []
  if (shipments.some((item) => item && item.signingType === '终车签收')) {
    return '当前浇筑令已终车签收，不可提交补方申请。'
  }
  const approved = Number(order.approvedQuantity) || 0
  const signed = Number(order.signedQuantity) || 0
  if (approved <= 0 || signed + 0.01 < approved) {
    return '合格签收未达到申请量，不可提交补方申请。'
  }
  return ''
}

export default {
  namespaced: true,
  state: {
    pouringOrderList: {}, // 浇筑令列表
    unfinishedPouringOrderList: [],
    pouringOrderInfo: {}, // 浇筑令信息
    historyApplied: {} // 浇筑分项某标号历史申请数据
  },
  getters: {},
  actions: {
    // 新增浇筑令信息（扁平表单组装为 pouringOrder + concretePouring）
    async addPouringOrder({ dispatch, rootState }, data) {
      const source = data || {}
      const displayName =
        (rootState.user &&
          (rootState.user.personName || rootState.user.userName)) ||
        ''
      const concretePouring = {
        ...(source.concretePouring || {}),
        appliedQuantity:
          (source.concretePouring && source.concretePouring.appliedQuantity) !=
          null
            ? source.concretePouring.appliedQuantity
            : source.appliedQuantity,
        ambientTemperature:
          (source.concretePouring &&
            source.concretePouring.ambientTemperature) != null
            ? source.concretePouring.ambientTemperature
            : source.ambientTemperature,
        slump:
          (source.concretePouring && source.concretePouring.slump) ||
          source.slump,
        productionRequirements:
          (source.concretePouring &&
            source.concretePouring.productionRequirements) ||
          source.productionRequirements,
        remarks:
          (source.concretePouring && source.concretePouring.remarks) ||
          source.appliedRemarks ||
          source.remarks,
        appliedType:
          (source.concretePouring && source.concretePouring.appliedType) ||
          source.appliedType ||
          '初次',
        auditUser:
          (source.concretePouring && source.concretePouring.auditUser) ||
          source.auditUser,
        auditStatus:
          (source.concretePouring && source.concretePouring.auditStatus) ||
          source.auditStatus,
        reviewer:
          (source.concretePouring && source.concretePouring.reviewer) ||
          source.reviewer,
        appliedPerson:
          (source.concretePouring && source.concretePouring.appliedPerson) ||
          source.appliedPerson ||
          displayName
      }
      const pouringOrder = { ...source }
      delete pouringOrder.concretePouring
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/fixed/pouringorder',
          data: { pouringOrder, concretePouring },
          msg: '新增浇筑令信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除浇筑令信息
    async deletePouringOrder({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/fixed/pouringorder',
          data: { uid: uid },
          msg: '删除浇筑令信息成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑浇筑令信息
    async editPouringOrder({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fixed/pouringorder',
          data: data,
          msg: '编辑浇筑令信息成功'
        },
        { root: true }
      )
      return res
    },
    // 获取砼浇筑令列表
    async getPouringOrderList({ rootState, commit, dispatch }, data) {
      var queryValues = {
        orgUid: data && data.orgUid ? data.orgUid : rootState.user.orgValue,
        strengthGrade:
          data && data.strengthGrade
            ? data.strengthGrade
            : rootState.queryValues.pouringOrder &&
              rootState.queryValues.pouringOrder.strengthGrade
            ? rootState.queryValues.pouringOrder.strengthGrade
            : '',
        isCompleted:
          data && data.isCompleted
            ? data.isCompleted
            : rootState.queryValues.pouringOrder &&
              rootState.queryValues.pouringOrder.isCompleted
            ? rootState.queryValues.pouringOrder.isCompleted
            : '',
        executeStatus:
          data && data.executeStatus !== undefined
            ? data.executeStatus
            : rootState.queryValues.pouringOrder &&
              rootState.queryValues.pouringOrder.executeStatus
            ? rootState.queryValues.pouringOrder.executeStatus
            : '',
        startTime:
          data && data.startTime
            ? data.startTime
            : rootState.queryValues.pouringOrder &&
              rootState.queryValues.pouringOrder.period
            ? rootState.queryValues.pouringOrder.period[0]
            : '',
        endTime:
          data && data.endTime
            ? data.endTime
            : rootState.queryValues.pouringOrder &&
              rootState.queryValues.pouringOrder.period
            ? rootState.queryValues.pouringOrder.period[1]
            : '',
        query:
          data && data.query
            ? data.query
            : rootState.queryValues.pouringOrder &&
              rootState.queryValues.pouringOrder.query
            ? rootState.queryValues.pouringOrder.query
            : '',
        page: data && data.page ? data.page : rootState.page.pouringOrder,
        limit: data && data.limit ? data.limit : rootState.limit.pouringOrder
      }
      const displayStatusFilter = queryValues.executeStatus
      if (
        displayStatusFilter === '待审核' ||
        displayStatusFilter === '待补方审核'
      ) {
        queryValues.executeStatus = ''
      }
      queryValues = removeNull(queryValues)
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/pouringorderlist',
          data: queryValues
        },
        { root: true }
      )
      var pouringOrderList = res.data ? res.data : {}
      if (!pouringOrderList.result) pouringOrderList.result = []
      const adminName = rootState.superAdminName || 'dpnadmin'
      const isSuperAdmin =
        rootState.user.userName === adminName ||
        rootState.user.personName === adminName
      pouringOrderList.result.forEach((item) => {
        item.disabledButtons = []
        item.pouringLocation = item.remarks
          ? item.subitemName + '(' + item.remarks + ')'
          : item.subitemName
        item.executeStatus = resolveDisplayExecuteStatus(item)
        item.isCompleted = item.isCompleted === '0' ? '否' : '是'
        item.completedTime = item.completedTime ? item.completedTime : '/'
        item.timeText =
          '计划：' +
          (item.plannedPouringTime || '-') +
          '\n完成：' +
          (item.completedTime && item.completedTime !== '/'
            ? item.completedTime
            : '-')
        item.shipmentList = item.shipmentList ? item.shipmentList : []
        item.appliedList = item.appliedList ? item.appliedList : []
        item.approvedQuantity = item.appliedList.reduce((per, cur) => {
          return cur.auditStatus === '1' ? per + cur.appliedQuantity : per
        }, 0)
        item.auditQuantity = item.appliedList.reduce((per, cur) => {
          return cur.auditStatus === '2' ? per + cur.appliedQuantity : per
        }, 0)
        item.currentAppliedQuantity =
          item.approvedQuantity +
          item.auditQuantity +
          (item.auditQuantity ? '（待审\xa0' + item.auditQuantity + '）' : '')
        item.signedQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '合格签收'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.shipmentQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '运输中'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.loadingQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '待发车' ||
            cur.shipmentStatus === '待装车'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.pendingLoadQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '待装车'
            ? per + (Number(cur.shipmentQuantity) || 0)
            : per
        }, 0)
        item.abandonedQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '不合格签收'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.completedQuantity =
          '装\xa0' +
          item.loadingQuantity +
          '\xa0|\xa0运\xa0' +
          item.shipmentQuantity +
          '\xa0|\xa0签\xa0' +
          item.signedQuantity +
          '\xa0|\xa0废\xa0' +
          item.abandonedQuantity
        if (
          item.appliedList.length > 1 ||
          (item.appliedList.length === 1 && item.auditQuantity)
        ) {
          item.disabledButtons.push(0)
        }
        if (supplyApplicationBlockReason(item)) {
          item.disabledButtons.push(2)
        }
        // 机构用户：有运输单不可删；超管开放强制删除（后端级联清运输单/生产任务）
        if (item.shipmentList.length && !isSuperAdmin) {
          item.disabledButtons.push(1)
        }
        // 中止按钮（索引3）：已中止/已完成不可再中止
        if (item.executeStatus === '已中止' || item.executeStatus === '已完成') {
          item.disabledButtons.push(3)
        }
      })
      if (
        displayStatusFilter === '待审核' ||
        displayStatusFilter === '待补方审核'
      ) {
        pouringOrderList.result = pouringOrderList.result.filter(
          (item) => item.executeStatus === displayStatusFilter
        )
        pouringOrderList.totalSize = pouringOrderList.result.length
      }
      pouringOrderList.result = sortArray(
        pouringOrderList.result,
        ['isCompleted', 'plannedPouringTime'],
        [['否', '是'], '']
      )
      commit(
        'baseSet',
        {
          module: 'pouringOrder',
          key: 'pouringOrderList',
          value: pouringOrderList
        },
        { root: true }
      )
      return pouringOrderList
    },
    // 获取未完成砼浇筑令列表
    async getUnfinishedPouringOrderList({ rootState, commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/orgpouringorder',
          data: {
            orgUid: data && data.orgUid ? data.orgUid : rootState.user.orgValue,
            isCompleted: data && data.isCompleted ? data.isCompleted : '0'
          }
        },
        { root: true }
      )
      var unfinishedPouringOrderList = res.data ? res.data : []
      unfinishedPouringOrderList.forEach((item) => {
        item.value = item.uid
        item.pouringLocation = item.remarks
          ? item.subitemName + '(' + item.remarks + ')'
          : item.subitemName
        item.isCompleted = item.isCompleted === '0' ? '否' : '是'
        item.completedTime = item.completedTime ? item.completedTime : '/'
        item.shipmentList = item.shipmentList ? item.shipmentList : []
        item.appliedList = item.appliedList ? item.appliedList : []
        item.approvedQuantity = item.appliedList.reduce((per, cur) => {
          return cur.auditStatus === '1' ? per + cur.appliedQuantity : per
        }, 0)
        item.auditQuantity = item.appliedList.reduce((per, cur) => {
          return cur.auditStatus === '2' ? per + cur.appliedQuantity : per
        }, 0)
        item.currentAppliedQuantity =
          item.approvedQuantity +
          item.auditQuantity +
          (item.auditQuantity ? '（待审\xa0' + item.auditQuantity + '）' : '')
        item.signedQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '合格签收'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.shipmentQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '运输中'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.loadingQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '待发车' ||
            cur.shipmentStatus === '待装车'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.pendingLoadQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '待装车'
            ? per + (Number(cur.shipmentQuantity) || 0)
            : per
        }, 0)
        item.abandonedQuantity = item.shipmentList.reduce((per, cur) => {
          return cur.shipmentStatus === '不合格签收'
            ? per + cur.shipmentQuantity
            : per
        }, 0)
        item.completedQuantity =
          '装\xa0' +
          item.loadingQuantity +
          '\xa0|\xa0运\xa0' +
          item.shipmentQuantity +
          '\xa0|\xa0签\xa0' +
          item.signedQuantity +
          '\xa0|\xa0废\xa0' +
          item.abandonedQuantity
        item.label =
          item.workType +
          ' ' +
          item.pouringOrderCode +
          ' ' +
          item.pouringLocation +
          ' ' +
          item.strengthGrade +
          ' ' +
          item.currentAppliedQuantity +
          'm³'
      })
      commit(
        'baseSet',
        {
          module: 'pouringOrder',
          key: 'unfinishedPouringOrderList',
          value: unfinishedPouringOrderList
        },
        { root: true }
      )
      return unfinishedPouringOrderList
    },
    // 获取浇筑令信息
    async getPouringOrderInfo(
      { state, rootState, rootGetters, commit, dispatch },
      uid
    ) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/pouringorderinfo',
          data: { uid: uid ? uid : state.pouringOrderInfo.uid }
        },
        { root: true }
      )
      var pouringOrderInfo = res.data ? res.data : {}
      pouringOrderInfo.pouringLocation = pouringOrderInfo.remarks
        ? pouringOrderInfo.subitemName + '(' + pouringOrderInfo.remarks + ')'
        : pouringOrderInfo.subitemName
      pouringOrderInfo.appliedList = pouringOrderInfo.appliedList
        ? pouringOrderInfo.appliedList
        : []
      pouringOrderInfo.shipmentList = pouringOrderInfo.shipmentList
        ? pouringOrderInfo.shipmentList
        : []
      pouringOrderInfo.approvedQuantity = pouringOrderInfo.appliedList.reduce(
        (per, cur) => {
          return cur.auditStatus === '1' ? per + cur.appliedQuantity : per
        },
        0
      )
      pouringOrderInfo.auditQuantity = pouringOrderInfo.appliedList.reduce(
        (per, cur) => {
          return cur.auditStatus === '2' ? per + cur.appliedQuantity : per
        },
        0
      )
      pouringOrderInfo.currentAppliedQuantity =
        pouringOrderInfo.approvedQuantity +
        pouringOrderInfo.auditQuantity +
        (pouringOrderInfo.auditQuantity
          ? '（待审\xa0' + pouringOrderInfo.auditQuantity + '）'
          : '')
      const userRoles = getSameAttribute(
        rootGetters['user/orgUserRoles'],
        'roleCode'
      ).values
      pouringOrderInfo.appliedList.forEach((list) => {
        list.disabledButtons = []
        if (list.auditStatus !== '2') {
          list.disabledButtons.push(0, 1, 2)
        }
        if (!userRoles.includes(list.auditUser)) {
          list.disabledButtons.push(2)
        }
        list.status =
          list.auditStatus === '2'
            ? '待审核'
            : list.auditStatus === '1'
            ? '审核通过'
            : '审核拒绝'
        list.appliedRemarks = list.remarks
      })
      pouringOrderInfo.shipmentList = sortArray(pouringOrderInfo.shipmentList, [
        'trainNumber'
      ])
      pouringOrderInfo.shipmentList.forEach((list) => {
        list.disabledButtons = []
        list.appliedRemarks = list.remarks
        list.monitoring = rootState.officialCar.carList.find((car) => {
          return car.carPlate === list.carCode
        })
        list.signQcodeInfo = buildShipmentSignQcodeInfo(list)
        list.qcodeInfo = list.signQcodeInfo
        // 按钮：0监控 1签收 2二维码
        if (!list.monitoring) {
          list.disabledButtons.push(0)
        }
        if (list.shipmentStatus !== '运输中') {
          list.disabledButtons.push(1)
        }
      })
      pouringOrderInfo.signedQuantity = pouringOrderInfo.shipmentList.reduce(
        (per, cur) => {
          return cur.shipmentStatus === '合格签收'
            ? per + cur.shipmentQuantity
            : per
        },
        0
      )
      pouringOrderInfo.shipmentQuantity = pouringOrderInfo.shipmentList.reduce(
        (per, cur) => {
          return cur.shipmentStatus === '运输中'
            ? per + cur.shipmentQuantity
            : per
        },
        0
      )
      pouringOrderInfo.loadingQuantity = pouringOrderInfo.shipmentList.reduce(
        (per, cur) => {
          return cur.shipmentStatus === '待发车'
            ? per + cur.shipmentQuantity
            : per
        },
        0
      )
      pouringOrderInfo.abandonedQuantity = pouringOrderInfo.shipmentList.reduce(
        (per, cur) => {
          return cur.shipmentStatus === '不合格签收'
            ? per + cur.shipmentQuantity
            : per
        },
        0
      )
      pouringOrderInfo.completedQuantity =
        '装\xa0' +
        pouringOrderInfo.loadingQuantity +
        '\xa0|\xa0运\xa0' +
        pouringOrderInfo.shipmentQuantity +
        '\xa0|\xa0签\xa0' +
        pouringOrderInfo.signedQuantity +
        '\xa0|\xa0废\xa0' +
        pouringOrderInfo.abandonedQuantity
      const historyApplied = await dispatch('getHistoryAppliedList', {
        subitemUid: pouringOrderInfo.subitemUid,
        strengthGrade: pouringOrderInfo.strengthGrade
      })
      pouringOrderInfo.audit = historyApplied.audit
      pouringOrderInfo.historyApplied =
        historyApplied.audit +
        historyApplied.approved +
        (!historyApplied.audit ? 0 : '（待审\xa0' + historyApplied.audit + '）')
      commit(
        'baseSet',
        {
          module: 'pouringOrder',
          key: 'pouringOrderInfo',
          value: pouringOrderInfo
        },
        { root: true }
      )
      return pouringOrderInfo
    },
    // 通过浇筑部位分项对应某标号混凝土累计申请数据
    async getHistoryAppliedList({ commit, dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/fixed/totalquantity',
          data: data
        },
        { root: true }
      )
      var appliedList = res.data ? res.data : []
      appliedList.forEach((item) => {
        item.status =
          item.auditStatus === '2'
            ? '待审核'
            : item.auditStatus === '1'
            ? '审核通过'
            : '审核拒绝'
      })
      var historyApplied = {
        list: appliedList,
        audit: appliedList.reduce((per, cur) => {
          return cur.auditStatus === '2' ? per + cur.appliedQuantity : per
        }, 0),
        approved: appliedList.reduce((per, cur) => {
          return cur.auditStatus === '1' ? per + cur.appliedQuantity : per
        }, 0)
      }
      commit(
        'baseSet',
        {
          module: 'pouringOrder',
          key: 'historyApplied',
          value: historyApplied
        },
        { root: true }
      )
      return historyApplied
    },
    // 新增补方信息
    async addAppliedInfo({ dispatch, rootState }, data) {
      const displayName =
        (rootState.user &&
          (rootState.user.personName || rootState.user.userName)) ||
        ''
      const payload = Object.assign({}, data || {})
      if (!payload.appliedPerson) {
        payload.appliedPerson = displayName
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/fixed/concretepouringapplication',
          data: payload,
          msg: '新增浇筑令补方信息成功'
        },
        { root: true }
      )
      return res
    },
    // 编辑申请信息
    async editAppliedInfo({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fixed/concretepouringapplication',
          data: data,
          msg: '编辑混凝土申请信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除混凝土申请信息
    async deleteAppliedInfo({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/fixed/concretepouringapplication',
          data: { uid: uid },
          msg: '删除混凝土申请信息成功'
        },
        { root: true }
      )
      return res
    },
    // 审核申请信息
    async approveAppliedInfo({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fixed/pouringorderaduit',
          data: data
        },
        { root: true }
      )
      return res
    },
    // 中止浇筑令（通知拌合站处理生产任务）
    async terminatePouringOrder({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/fixed/pouringorderterminate',
          data: data
        },
        { root: true }
      )
      return res
    }
  }
}
